import { Injectable } from '@angular/core';
import { App } from '@capacitor/app';
import { Capacitor } from '@capacitor/core';
import { environment as defaultEnvironment } from '../../../environments/environment';
import { AMBIENTE } from '../../../environments/ambiente';

type Ambiente = 'hom' | 'prod';

interface Cidade {
    /** Trechos do domínio que identificam a cidade no navegador. */
    dominios: string[];
    /** Pacote do app da cidade nas lojas. */
    pacote: string;
    carregar: Record<Ambiente, () => Promise<{ environment: object }>>;
}

const CIDADES: Cidade[] = [
    {
        dominios: ['franco'],
        pacote: 'com.educafrancodarocha.alunos',
        carregar: {
            hom: () => import('../../../environments/environment.francodarocha_hom'),
            prod: () => import('../../../environments/environment.francodarocha_prod'),
        },
    },
    {
        dominios: ['mairipora'],
        pacote: 'com.mairiporaeducasim.alunos',
        carregar: {
            hom: () => import('../../../environments/environment.mairipora_hom'),
            prod: () => import('../../../environments/environment.mairipora_prod'),
        },
    },
    {
        dominios: ['guara'],
        pacote: 'com.educaguara.alunos',
        carregar: {
            hom: () => import('../../../environments/environment.guaratingueta_hom'),
            prod: () => import('../../../environments/environment.guaratingueta_prod'),
        },
    },
    {
        dominios: ['ilhabela'],
        pacote: 'com.educailha.alunos',
        carregar: {
            hom: () => import('../../../environments/environment.ilhabela_hom'),
            prod: () => import('../../../environments/environment.ilhabela_prod'),
        },
    },
    {
        // Produção em educaita.com.br; homologação em homolog-aluno-itanhaem
        dominios: ['educaita', 'itanhaem'],
        pacote: 'com.educaita.alunos',
        carregar: {
            hom: () => import('../../../environments/environment.itanhaem_hom'),
            prod: () => import('../../../environments/environment.itanhaem_prod'),
        },
    },
    {
        dominios: ['nilopolis'],
        pacote: 'com.nilopoliseduca.alunos',
        carregar: {
            hom: () => import('../../../environments/environment.nilopolis_hom'),
            prod: () => import('../../../environments/environment.nilopolis_prod'),
        },
    },
    {
        dominios: ['cacapava'],
        pacote: 'com.educacacapava.alunos',
        carregar: {
            hom: () => import('../../../environments/environment.cacapava_hom'),
            prod: () => import('../../../environments/environment.cacapava_prod'),
        },
    },
    {
        dominios: ['paraisopolis'],
        pacote: 'com.educaparaisopolis.alunos',
        carregar: {
            hom: () => import('../../../environments/environment.paraisopolis_hom'),
            prod: () => import('../../../environments/environment.paraisopolis_prod'),
        },
    },
];

@Injectable({
    providedIn: 'root',
})
export class EnvironmentLoaderService {
    private envConfig: any = defaultEnvironment;

    /**
     * Escolhe o environment da cidade antes de iniciar o Angular:
     * - navegador: cidade e ambiente pelo domínio (um build serve todas as cidades);
     * - app nativo: cidade pelo pacote do app e ambiente pelo build (AMBIENTE), para o mesmo
     *   pacote web servir os apps de todas as cidades (atualização pelo ar).
     */
    async loadEnvironment(): Promise<void> {
        let cidade: Cidade | undefined;
        let ambiente: Ambiente;

        if (Capacitor.isNativePlatform()) {
            const { id } = await App.getInfo();
            cidade = CIDADES.find(c => c.pacote === id);
            ambiente = AMBIENTE === 'homologacao' ? 'hom' : 'prod';
        } else {
            const url = window.location.href;
            cidade = CIDADES.find(c => c.dominios.some(d => url.includes(d)));
            ambiente = url.includes('homolog') ? 'hom' : 'prod';
        }

        if (!cidade) {
            return;
        }
        const env = await cidade.carregar[ambiente]();
        this.envConfig = env.environment;
        Object.assign(defaultEnvironment, this.envConfig);
    }

    getEnvironment() {
        return this.envConfig;
    }
}
